import { render, staticRenderFns } from "./CheckoutHeader.vue?vue&type=template&id=c5a9ba20&scoped=true"
import script from "./CheckoutHeader.vue?vue&type=script&lang=js"
export * from "./CheckoutHeader.vue?vue&type=script&lang=js"
import style0 from "./CheckoutHeader.vue?vue&type=style&index=0&id=c5a9ba20&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5a9ba20",
  null
  
)

export default component.exports